<template>
  <div
    :class="`mark ${mark.handleNext ? 'mark--next' : ''} ${(selectedMark && ((mark._id || mark.id) === (selectedMark._id || selectedMark.id))) ? 'mark--active' : ''}`"
    ref="draggableMark"
    :style="{left: `${mark.x}%`, top: `${mark.y}%`}"
    @click="onClick"
  >
    <img :src="`${mark.image}`" class="mark__image" />
    <span class="mark__text" v-html="mark.label[lang]" />
  </div>
</template>

<script>
import { initDraggable } from "../../utils";
import { mapState, mapMutations } from "vuex";
import { setTimeout } from "timers";

export default {
  data() {
    return {
      x: 0,
      y: 0
    };
  },
  computed: {
    ...mapState(["lang", "selectedScene", "selectedProject", "selectedMark"])
  },
  props: {
    mark: Object,
    draggable: Boolean,
    handleClick: Function
  },
  methods: {
    ...mapMutations([
      "setSelectedScene",
      "setSelectedProject",
      "setSelectedMark",
      "saveLocalScene",
      "addUnsavedScene"
    ]),
    onClick() {
      this.setSelectedMark(this.mark);
      if (this.handleClick) {
        this.handleClick();
      }
    }
  },
  mounted() {
    if (this.draggable) {
      const { draggableMark } = this.$refs;

      setTimeout(() => {
        const bounds = draggableMark.getBoundingClientRect();
        const {
          height,
          width
        } = this.$el.parentElement.getBoundingClientRect();
        const x = (this.mark.x * width) / 100;
        const y = (this.mark.y * height) / 100;

        draggableMark.setAttribute("data-x", x);
        draggableMark.setAttribute("data-y", y);
      }, 100);

      initDraggable(draggableMark, event => {
        const bounds = draggableMark.getBoundingClientRect();
        const target = event.target;
        const { height, width } = target.parentElement.getBoundingClientRect();
        const x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
        const y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;
        const xPercentage = 100 * (x / width);
        const yPercentage = 100 * (y / height);

        this.mark.x = xPercentage;
        this.mark.y = yPercentage;

        this.saveLocalScene(this.selectedScene);
        this.addUnsavedScene(this.selectedScene);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.mark {
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  word-wrap: break-word;
  text-align: left;
  z-index: 7;
  background: none;
  background-color: #7a9cb5;
  color: #fff;
  padding: 0 35px 0 60px;
  min-width: auto;
  // max-width: 420px;
  white-space: nowrap;
  font-size: 27px;

  &--next {
    min-width: 330px;
    background: url("~@/assets/flag-inner.svg") no-repeat right center;
    background-size: cover;
    white-space: nowrap;
    padding: 0 35px 0 130px;
    color: #004169;
  }

  &__text {
    display: table-cell;
    height: 105px;
    vertical-align: middle;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  &__image {
    position: absolute;
    // height: 100%;
    min-height: 105px;
    min-width: 115px;
    max-height: 105px;
    max-width: 115px;
    z-index: 1;
    object-fit: contain;
    left: -60px;
    top: 50%;
    margin-top: -52.5px;
  }

  &--active {
    box-shadow: 0px 0px 0px 2px rgb(255, 255, 255);
  }
}
</style>

